import type { ApiClient } from "@pokifolio/api-client";
import { createContext, useContext } from "react";

export const ApiContext = createContext<ApiClient | null>(null);

/** The API client for the current app. Screens call the backend only through this. */
export function useApi(): ApiClient {
  const api = useContext(ApiContext);
  if (api === null) throw new Error("useApi must be used inside <ApiProvider>");
  return api;
}
